export default {
  format: 'YYYY-MM-DD',
  lang: {
    start: '开始时间',
    end: '结束时间',
  },
};